import axios from 'axios'

// 获取RSA公钥
export function getPublicKey() {
  return axios.post('/auth/getPublicKey')
    .then(response => response.data)
    .catch(error => {
      console.error('获取公钥失败:', error)
      throw error
    })
}
